import { render, staticRenderFns } from "./chinese.vue?vue&type=template&id=8fce756c"
import script from "./chinese.vue?vue&type=script&lang=js"
export * from "./chinese.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports